import { useLocale } from '../../application/i18n/LocaleProvider';
import { usePlantArrivalNotifications } from '../../application/notifications/usePlantArrivalNotifications';

/**
 * Keeps the catalogue watch running for as long as the app is open (SPEC-016).
 *
 * Renders nothing. It exists only so the hook runs somewhere always mounted and
 * inside the locale provider — the watch needs the active locale twice over: to
 * write the notification in the right language, and to build a deep link that
 * carries its locale, because every URL in this app does (CON-002).
 *
 * Mounted beside the routes rather than inside a screen, so browsing from the
 * catalogue to a plant and back does not restart the watch and re-check.
 *
 * It never asks for permission. The watch records what it read whatever the
 * permission is, and announces only when it is already `granted`, so app start
 * cannot prompt someone who has not opted in.
 */
export default function PlantArrivalWatch() {
    const { localeCode, languageCode } = useLocale();

    usePlantArrivalNotifications({ localeCode, languageCode });

    return null;
}
